export const DEFAULT_HISTORY_LIMIT = 50

export interface History<T> {
  past: T[]
  present: T
  future: T[]
  limit: number
}

export function initHistory<T>(present: T, limit = DEFAULT_HISTORY_LIMIT): History<T> {
  return { past: [], present, future: [], limit }
}

export function push<T>(history: History<T>, next: T): History<T> {
  const nextPast = [...history.past, history.present]
  const trimmed = nextPast.length > history.limit ? nextPast.slice(-history.limit) : nextPast
  return {
    ...history,
    past: trimmed,
    present: next,
    future: [],
  }
}

export function canUndo<T>(history: History<T>): boolean {
  return history.past.length > 0
}

export function canRedo<T>(history: History<T>): boolean {
  return history.future.length > 0
}

export function undo<T>(history: History<T>): History<T> {
  if (!canUndo(history)) return history
  const previous = history.past[history.past.length - 1]!
  const nextPast = history.past.slice(0, -1)
  return {
    ...history,
    past: nextPast,
    present: previous,
    future: [history.present, ...history.future],
  }
}

export function redo<T>(history: History<T>): History<T> {
  if (!canRedo(history)) return history
  const next = history.future[0]!
  const nextFuture = history.future.slice(1)
  return {
    ...history,
    past: [...history.past, history.present],
    present: next,
    future: nextFuture,
  }
}

export function resetHistory<T>(history: History<T>, present: T): History<T> {
  return { ...history, past: [], present, future: [] }
}
